import React, { lazy, Suspense } from 'react';
import { createPortal } from 'react-dom';

// Heavy, rarely-open UI loaded on demand instead of in the startup bundle.
// Each wrapper renders (and first downloads) its component only while open.

const CameraModalImpl = lazy(() => import('./CameraModal'));
const ImageEditorModalImpl = lazy(() => import('./ImageEditorModal'));
const EmojiPickerImpl = lazy(() => import('emoji-picker-react'));

export const CameraModal = (props) =>
  props.isOpen ? (
    <Suspense
      fallback={
        typeof document !== 'undefined'
          ? createPortal(<div className="fixed inset-0 z-[100] bg-black" />, document.body)
          : null
      }
    >
      <CameraModalImpl {...props} />
    </Suspense>
  ) : null;

export const ImageEditorModal = (props) =>
  props.isOpen ? (
    <Suspense fallback={null}>
      <ImageEditorModalImpl {...props} />
    </Suspense>
  ) : null;

export const EmojiPicker = ({ width = 300, height = 300, ...props }) => (
  <Suspense fallback={<div style={{ width, height }} className="skeleton" />}>
    <EmojiPickerImpl width={width} height={height} {...props} />
  </Suspense>
);
